"use client";

import { createConsoleCommands } from "@/services/cookies/feature-flags.service";

/**
 * Initialize feature flags for all environments
 */
export const initFeatureFlags = (): void => {
  if (typeof window !== "undefined") {
    createConsoleCommands();

    // Show welcome message with environment info
    const env = process.env.NEXT_PUBLIC_ENV || process.env.NODE_ENV || 'unknown';
    const isDev = process.env.NODE_ENV === "development";

    if (isDev) {
      console.log(
        "%c🚩 Feature Flags System Initialized (Development)",
        "color: #10B981; font-weight: bold",
      );
    } else {
      console.log(
        `%c🚩 Feature Flags System Initialized (${env})`,
        "color: #059669; font-weight: bold",
      );
    }

    console.log("Type AvezorFlags.help() to see available commands");

    // Show available flags count
    if ((window as any).AvezorFlags) {
      const flagsCount = (window as any).AvezorFlags.keys().length;
      console.log(`Available feature flags: ${flagsCount}`);
    }
  }
};
